var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3",
    "data-name": "Component 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.268,
    height: 26.545,
    viewBox: "0 0 34.268 26.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M130.034,308.579q0,5.24,0,10.479a2.543,2.543,0,0,1-1.868,2.685,2.469,2.469,0,0,1-2.407-.552c-2.574-2.177-5.139-4.363-7.729-6.521a1.7,1.7,0,0,0-.959-.346c-1.2-.051-2.412.021-3.61-.068a3.146,3.146,0,0,1-2.894-3.08q-.05-2.589,0-5.179a3.157,3.157,0,0,1,2.947-3.094c1.18-.075,2.369,0,3.551-.059a1.8,1.8,0,0,0,1-.382q3.818-3.176,7.592-6.4a2.576,2.576,0,0,1,4.373,1.982Q130.039,303.31,130.034,308.579ZM126.843,318V299.166c-2.32,1.967-4.59,3.851-6.807,5.794a3.794,3.794,0,0,1-2.834,1.055c-.961-.05-1.927-.012-2.891-.008-.193,0-.385.023-.577.036v5.127c1.124,0,2.209.053,3.286-.013a4.115,4.115,0,0,1,3.155,1.166C122.334,314.241,124.569,316.073,126.843,318Z",
    transform: "translate(-110.54 -295.309)",
    fill: "#fcac00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M171.086,310.234a14.442,14.442,0,0,1-5.378,11.208,1.32,1.32,0,1,1-1.666-2.022,11.772,11.772,0,0,0,.023-18.342,1.32,1.32,0,1,1,1.62-2.058A14.447,14.447,0,0,1,171.086,310.234Z",
    transform: "translate(-136.817 -296.966)",
    fill: "#fcac00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M161.735,314.214a7.316,7.316,0,0,0-2.22-5.328,2.116,2.116,0,0,1-.564-.884,1.076,1.076,0,0,1,.568-1.273,1.2,1.2,0,0,1,1.495.183,9.469,9.469,0,0,1,3.079,5.7,9.615,9.615,0,0,1-2.908,8.643,1.257,1.257,0,1,1-1.717-1.775A7.181,7.181,0,0,0,161.735,314.214Z",
    transform: "translate(-134.568 -300.893)",
    fill: "#fcac00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M157.2,318.277a4.8,4.8,0,0,1-.84,2.842,1.156,1.156,0,1,1-1.959-1.22,2.928,2.928,0,0,0-.017-3.281,1.107,1.107,0,0,1,.349-1.617,1.135,1.135,0,0,1,1.613.4A4.789,4.789,0,0,1,157.2,318.277Z",
    transform: "translate(-132.217 -304.998)",
    fill: "#fcac00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volumeUp.a89d37517ccfed895db1b76632d15b90.svg";
export { ForwardRef as ReactComponent };